import React, { useState, useEffect } from 'react';

import {
  Master,
  StoresDetail,
  TableDetails,
  TitlePage,
  PageWrapper,
  PanelTopWrapper,
  ContentWrapper,
  InputSearch,
  StoresList,
  ImportData,
  AlertMessage,
  PaginationList,
  Loader
} from 'components';
import { Button } from 'reactstrap';
import { StorePopulate, UpdateStoreService, PostImportData, MessageRequest, GetSpreadSheetService } from 'services';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';

export const StoresPage = (props) => {
  let { path } = useRouteMatch();
  let history = useHistory();

  const [page, setPage] = useState(0);
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [contentPagination, setContentPagination ] = useState([])
  const [textSearch, setTextSearch ] = useState(false);
  const [showLoader, setShowLoader ] = useState(false);

  const toggle = (value) => {
    setActive(value);
  }

  const resetPage = ()=> {
    setPage(0);
  }

  const changePage = (page) => {
    setPage(page - 1);
  }

  useEffect(() => {
    StorePopulate(page, textSearch).then((stores) =>{
      setContentPagination(stores, textSearch);
    } );
  }, [page, history.location.pathname, textSearch]);

  const titles = [
    '',
    'Nome da Loja',
    'Link',
    'Cliques no mês',
    'Total cliques',
    'Ativo',
    'Editar',
  ];


  const updateEnabled = (status) => {
    const enabled = {
      enabled: status.enable
    }
    UpdateStoreService( enabled, status.id);
  }

  const sendFile = (file)=> {

    if(file){
      const formData = new FormData();
      formData.append("file", file);
      setShowLoader(true)
      PostImportData(formData).then((response)=> {
        setShowLoader(false);
        MessageRequest("Planilha importada", response, setMessage, setActive);
      });
    }
  }

  const search = (value)=> {
    setTextSearch(value);
  }

  const exportSpreadSheet = () => {
    GetSpreadSheetService({url: "store/export"});
  }

  return (
    <>
      <Master>
        <Switch>
          <Route exact path={path}>
            <PageWrapper>
              <PanelTopWrapper padding={"py-4"}>
                <TitlePage title={'Lojas'} />
                <ContentWrapper class={'d-flex align-items-center'}>
                  <InputSearch placeholder={'Filtrar loja...'} getSearch={search} reset={resetPage} />
                  <StoresList />
                </ContentWrapper>
              </PanelTopWrapper>
              <TableDetails promise={contentPagination} titles={titles} getStatus={updateEnabled} />
              <ContentWrapper class={'d-flex align-items-center'}>
                <ImportData getBinary={sendFile}/>
                <Button color="primary" onClick={exportSpreadSheet}> Exportar Lojas </Button>
              </ContentWrapper>
              <PaginationList page={contentPagination} changePage={changePage}/>
            </PageWrapper>
          </Route>
          <Route path={`${path}/:topicId`}>
            <StoresDetail />
          </Route>
        </Switch>
        <AlertMessage message={message} active={active} toggle={toggle} />
        <Loader show={showLoader} message={'Importando dados da planilha...'}/>
      </Master>
    </>
  );
};
